/* Hero-video: loop verzekeren en autoplay opnieuw proberen als de browser 'm blokkeert */
  (function () {
    function nudge() {
      document.querySelectorAll('.bk-hero-video').forEach(function (v) {
        v.muted = true;
        v.loop = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    function bindOnce() {
      ['touchstart', 'click', 'scroll', 'keydown'].forEach(function (evt) {
        document.addEventListener(evt, nudge, { once: true, passive: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nudge(); bindOnce(); });
    else { nudge(); bindOnce(); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) nudge(); });
  })();


  /* Before / After slider — drag handler */
  (function () {
    function initOneSlider(slider) {
      if (!slider || slider.dataset.bound === '1') return;
      slider.dataset.bound = '1';
      var compare = slider.querySelector('.bk-ba-compare');
      var afterWrap = slider.querySelector('.bk-ba-after-wrap');
      var afterImg = slider.querySelector('.bk-ba-after-wrap .bk-ba-after');
      var handle = slider.querySelector('.bk-ba-handle');
      if (!compare || !afterWrap || !handle) return;
      var dragging = false;
      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        afterWrap.style.width = pct + '%';
        if (afterImg) afterImg.style.width = (100 / (pct / 100)) + '%';
        handle.style.left = pct + '%';
        compare.dataset.pos = pct.toFixed(1);
        handle.setAttribute('aria-valuenow', Math.round(pct));
      }
      function onPointer(e) {
        var rect = compare.getBoundingClientRect();
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(((clientX - rect.left) / rect.width) * 100);
      }
      function start(e) {
        dragging = true;
        onPointer(e);
        if (e.cancelable) e.preventDefault();
      }
      function move(e) {
        if (!dragging) return;
        onPointer(e);
        /* Voorkomt page-scroll tijdens horizontaal slepen op mobile */
        if (e.cancelable && e.touches) e.preventDefault();
      }
      function end() { dragging = false; }
      compare.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      /* Touch listeners op compare zelf — non-passive zodat preventDefault werkt */
      compare.addEventListener('touchstart', start, { passive: false });
      compare.addEventListener('touchmove', move, { passive: false });
      compare.addEventListener('touchend', end);
      compare.addEventListener('touchcancel', end);
      /* Keyboard support */
      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(compare.dataset.pos || '50');
        if (e.key === 'ArrowLeft') { setPos(cur - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(cur + 5); e.preventDefault(); }
      });
      setPos(50);
    }
    function initAll() {
      /* Class selector zodat zowel desktop (#bk-ba-slider) als mobile (#bk-ba-slider-m) werken */
      document.querySelectorAll('.bk-ba-slider').forEach(initOneSlider);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
  })();
